export const SHARED_CONFIG: {
	projectId: string,
  cloudRegion: 'us-central1' | 'us-east1' | 'us-east4' | 'europe-west1' | 'europe-west2' | 'asia-east2' | 'asia-northeast1';
} = {
	projectId: 'bb-web-c1b44',
	cloudRegion: 'europe-west1',
};